import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Logo from '@/components/common/Logo';

const PoliticaPrivacidade = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-[#1A1A1A] text-white py-4">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/login" className="text-white/70 hover:text-white">
            <FiArrowLeft className="text-xl" />
          </Link>
          <Logo size="sm" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-[#1A1A1A] mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p className="text-sm text-gray-500">Última atualização: Janeiro de 2025</p>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">1. Introdução</h2>
            <p>
              O BarueriFlash está comprometido com a proteção da sua privacidade. Esta Política de 
              Privacidade explica como coletamos, usamos e protegemos suas informações pessoais, 
              em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">2. Dados que Coletamos</h2>
            <h3 className="text-lg font-medium mt-4 mb-2">Dados de Cadastro:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Nome completo</li>
              <li>Endereço de e-mail</li>
              <li>Senha (armazenada de forma criptografada)</li>
              <li>Tipo de usuário (cliente, lojista ou entregador)</li>
            </ul>

            <h3 className="text-lg font-medium mt-4 mb-2">Dados de Localização:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Endereço de entrega (CEP, rua, número)</li>
              <li>Coordenadas geográficas (para rastreamento de entregas)</li>
              <li>Localização em tempo real (apenas para entregadores durante entregas)</li>
            </ul>

            <h3 className="text-lg font-medium mt-4 mb-2">Dados de Transações:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Histórico de pedidos</li>
              <li>Informações de pagamento (processadas pelo Mercado Pago)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">3. Como Usamos seus Dados</h2>
            <p>Utilizamos seus dados para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Processar e entregar seus pedidos</li>
              <li>Permitir rastreamento em tempo real das entregas</li>
              <li>Enviar notificações sobre status de pedidos</li>
              <li>Processar pagamentos de forma segura</li>
              <li>Melhorar nossos serviços</li>
              <li>Cumprir obrigações legais</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">4. Compartilhamento de Dados</h2>
            <p>Seus dados podem ser compartilhados com:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Lojistas:</strong> Para preparação e confirmação de pedidos</li>
              <li><strong>Entregadores:</strong> Endereço de entrega para realização do serviço</li>
              <li><strong>Mercado Pago:</strong> Para processamento de pagamentos</li>
              <li><strong>Autoridades:</strong> Quando exigido por lei</li>
            </ul>
            <p className="mt-4">
              <strong>Não vendemos</strong> seus dados pessoais para terceiros.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">5. Segurança dos Dados</h2>
            <p>Implementamos medidas de segurança para proteger seus dados:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Criptografia de senhas (bcrypt)</li>
              <li>Conexões seguras (HTTPS)</li>
              <li>Tokens de autenticação (JWT)</li>
              <li>Acesso restrito aos dados</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">6. Seus Direitos (LGPD)</h2>
            <p>Você tem direito a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Acesso:</strong> Solicitar uma cópia dos seus dados</li>
              <li><strong>Correção:</strong> Corrigir dados incorretos</li>
              <li><strong>Exclusão:</strong> Solicitar a exclusão dos seus dados</li>
              <li><strong>Portabilidade:</strong> Receber seus dados em formato estruturado</li>
              <li><strong>Revogação:</strong> Retirar consentimento a qualquer momento</li>
            </ul>
            <p className="mt-4">
              Para exercer seus direitos, entre em contato conosco através do email 
              <a href="mailto:privacidade@barueriflash.com.br" className="text-[#DC143C] hover:underline ml-1">
                privacidade@barueriflash.com.br
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">7. Cookies e Tecnologias</h2>
            <p>
              Utilizamos cookies e tecnologias similares para manter sua sessão ativa e melhorar 
              sua experiência. Você pode gerenciar cookies através das configurações do seu navegador.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">8. Retenção de Dados</h2>
            <p>
              Mantemos seus dados pelo tempo necessário para fornecer nossos serviços e cumprir 
              obrigações legais. Dados de transações são mantidos pelo período exigido pela 
              legislação fiscal brasileira.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">9. Alterações</h2>
            <p>
              Esta política pode ser atualizada periodicamente. Notificaremos sobre alterações 
              significativas através do aplicativo ou e-mail.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mt-8 mb-4">10. Contato</h2>
            <p>
              Para questões sobre privacidade, entre em contato:
            </p>
            <ul className="list-none mt-2 space-y-1">
              <li>📧 Email: <a href="mailto:privacidade@barueriflash.com.br" className="text-[#DC143C] hover:underline">privacidade@barueriflash.com.br</a></li>
              <li>📍 Barueri, São Paulo - Brasil</li>
            </ul>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#DC143C] hover:underline font-medium"
          >
            <FiArrowLeft />
            Voltar
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white py-6 mt-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/faq" className="text-white/60 hover:text-white">FAQ</Link>
            <Link to="/sobre" className="text-white/60 hover:text-white">Sobre</Link>
            <Link to="/termos" className="text-white/60 hover:text-white">Termos</Link>
          </div>
          <p className="text-white/40 text-center text-xs mt-4">© 2025 BarueriFlash - Todos os direitos reservados</p>
        </div>
      </footer>
    </div>
  );
};

export default PoliticaPrivacidade;
